module.exports = __webpack_public_path__ + "static/media/laporan_absen_bidang_study.20fc1cd2.png";